import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, Typography } from "@mui/material";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import QuestSearchDialog from "@quest_editor/components/QuestSearchDialog";

function QuestUnparticipatedField({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation("questEditor");
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSearch = () => {
    setDialogOpen(true);
  };

  const handleSelect = (questIds: string[]) => {
    onChange(questIds.join(","));
  };

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <TextField
          size="small"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          sx={{ flexGrow: 1 }}
        />
        <SubActionButton onClick={handleSearch}>
          {t("quest_edit_target.button.search")}
        </SubActionButton>
        <Typography color="primary">
          {t("quest_edit_target.field.quest.unparticipated.note")}
        </Typography>
      </Stack>
      <QuestSearchDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSelect={handleSelect}
        initialSelectedIds={value ? value.split(",").filter(Boolean) : []}
      />
    </>
  );
}

export default QuestUnparticipatedField;
